import ShoppingListPage from './ShoppingListPage';

export default ShoppingListPage;
